/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Explainer_TitleInputs */



/**
* | output |
* | --- |
* | "How offline mode works" |
*
* @param {Offline_Explainer_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_explainer_title = /** @type {((inputs?: Offline_Explainer_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Explainer_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment fonctionne le mode hors ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cómo funciona el modo sin conexión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Como o modo offline funciona")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come funziona la modalità offline")
	return /** @type {LocalizedString} */ ("How offline mode works")
});